/*
    ttl = titulo
    stl = subtitulo
    btn = boton
    lbl = label
    cmp = campo
    msg = mensaje (incluye cualquier string en alerts, poups, snackbar)
    plh = placeholder
    txt = texto (Cualquier texto largo)
*/
export default ({
  
})